module.exports = __webpack_public_path__ + "media/images/introduction_sp-80f83fcfa8cf553ec6199e8f4b2d8537.png";